import styled from 'styled-components';

import { BORDER_RADIUS, COLORS } from '../../constants/theme';

export const FileListItem = styled.div`
  border-radius: ${({ compact }) => (compact ? '0' : '12px')};
  background-color: ${({ compact }) => (compact ? 'transparent' : COLORS.white)};
`;

export const FileTypeIconContainer = styled.div`
  width: 44px;
  height: 44px;
  background-color: ${COLORS.light.low};
  border-radius: 10px;
`;

export const UploadIconContainer = styled.div`
  border-top-left-radius: ${BORDER_RADIUS.medium};
  border-bottom-left-radius: ${BORDER_RADIUS.medium};
`;
